import { render, staticRenderFns } from "./ExtendMarket.vue?vue&type=template&id=3ded5dae&scoped=true"
import script from "./ExtendMarket.vue?vue&type=script&lang=js"
export * from "./ExtendMarket.vue?vue&type=script&lang=js"
import style0 from "./ExtendMarket.vue?vue&type=style&index=0&id=3ded5dae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded5dae",
  null
  
)

export default component.exports